export const baseModalTitles = {
  baseModalTitleProfileUser: "Profielgebruiker",
  baseModalTitleMobilePayment: "Herlaai",
  baseModalTitleInviteFriend: "Nooi 'n vriend",
  baseModalTitleChangePassword: "Verander wagwoord",
  baseModalTitleWithdrawal: "Onttrekking",
  baseModalTitleTransfer: "Stuur geld",
  baseModalTitleRegistration: "Teken in en wen!",
  baseModalTitleSupport: "Ondersteuning",
};
